<template>
  <div class="row">
    <input-select
      v-if="!this.ehProponente"
      class="col-12"
      label="Empresa investidora"
      :options="empresasSelect"
      ref="empresa"
      v-model="form.empresa"
      required
    />
    <input-textarea
      class="col-12"
      label="Descrição (Máximo 300 caracteres)"
      :max-length="300"
      ref="descricao"
      v-model="form.descricao"
      placeholder="Máximo 300 caracteres"
      required
    />
    <input-textarea
      class="col-12"
      label="Justificativa (Máximo 500 caracteres)"
      :max-length="500"
      ref="justificativa"
      v-model="form.justificativa"
      placeholder="Máximo 500 caracteres"
      required
    />

    <input-text
      class="col-12 col-md-4"
      label="Quantidade"
      ref="quantidade"
      v-model="form.quantidade"
      type="number"
      required
    />
    <input-money
      class="col-12 col-md-4"
      label="Valor individual"
      ref="valor"
      v-model="form.valorIndividual"
      required
    />
    <input-text
      class="col-12 col-md-4"
      label="Valor total"
      readonly
      v-model="total"
    />

    <input-select
      class="col-12 col-md-4"
      label="Origem da despesa"
      :options="options.origemDespesa"
      ref="origem"
      v-model="form.origemDespesa"
      required
    />
    <input-select
      class="col-12 col-md-4"
      label="Despesa de laboratório existente?"
      :options="options.simnao"
      ref="laboratorio_existente"
      v-model="form.despesaLaboratorioExistente"
      required
    />
    <input-select
      class="col-12 col-md-4"
      label="Despesa de laboratório novo?"
      :options="options.simnao"
      ref="laboratorio_novo"
      v-model="form.despesaLaboratorioNovo"
      required
    />

    <input-date-time
      class="col-12 col-md-3"
      label="Data de emissão"
      ref="data_emissao"
      v-model="form.dataEmissao"
      required
    />
    <input-select
      class="col-12 col-md-3"
      label="Tipo de documento"
      ref="tipo_documento"
      v-model="form.tipoDocumento"
      :options="options.tipoDocumentoProjeto"
      required
    />
    <input-text
      class="col-12 col-md-6"
      label="Nº do documento"
      ref="nr_documento"
      v-model="form.numeroDocumento"
      required
    />

    <input-text
      class="col-12"
      label="Beneficiado"
      ref="beneficiado"
      v-model="form.beneficiado"
      required
    />
    <div
      v-if="form.origemDespesa === 'Nacional' || form.origemDespesa == null"
      class="col-2 d-flex align-items-center justify-content-center"
    >
      <b-form-radio-group
        :options="options.tipoDocumento"
        v-model="form.documento"
      ></b-form-radio-group>
    </div>
    <input-mask
      v-if="form.origemDespesa === 'Nacional' || form.origemDespesa == null"
      :type="form.documento ? (form.documento == 'CPF' ? 'cpf' : 'cnpj') : ''"
      class="col-10"
      :mask="
        form.documento
          ? form.documento == 'CPF'
            ? mascara.cpf
            : mascara.cnpj
          : ''
      "
      label="Documento"
      ref="numero"
      v-model="form.cpfcnpj"
      required
    />
    <input-text
      v-else
      class="col-12"
      label="Invoice"
      ref="invoice"
      v-model="form.invoice"
      required
    />

    <div class="col-12 mb-2" v-if="form.comprovante">
      <upload
        v-if="!form.comprovanteAWS"
        id="comprovante"
        tituloArquivo="Arrastar comprovante"
        selecioneArquivo="Selecionar o comprovante"
        type=".*"
        :arquivo-download="form.comprovante.base64"
        :arquivo-download-nome="
          form.comprovante.nomeArquivo
            ? form.comprovante.nomeArquivo
            : form.comprovante.extensao
            ? `Comprovante.${form.comprovante.extensao}`
            : ''
        "
        @upload="
          (file, nomeArquivo, extensao) => {
            form.comprovante.nomeArquivo = nomeArquivo;
            form.comprovante.base64 = file;
            form.comprovante.extensao = extensao;
          }
        "
      />

      <template v-if="form.comprovanteAWS">
        <div>
          Comprovante
          <div class="lista-arquivos d-flex">
            <!-- <b-button variant="danger" @click="removerArquivo(tipoArquivoCusto.CP)" class="m-2" size="sm">
                            <b-icon icon="trash" class="mr-2" />
                            Remover arquivo
                        </b-button> -->
            <b-button
              variant="info"
              @click="baixarArquivo(form.id, tipoArquivoCusto.CP)"
              class="m-2"
              size="sm"
            >
              <i class="fas fa-cloud-download"></i>
            </b-button>
            <div
              style="border-left: 1px solid #e5e5e5"
              class="lista-arquivos__left d-flex pl-2 align-items-center"
            >
              {{ form.comprovanteAWS }}
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="col-12 mb-2">
      <upload
        v-if="!form.liquidacaoFinanceiraAWS"
        id="liquidacao"
        tituloArquivo="Arrastar liquidação financeira"
        selecioneArquivo="Selecionar a liquidação financeira"
        type=".*"
        :arquivo-download="form.liquidacaoFinanceira.base64"
        :arquivo-download-nome="
          form.liquidacaoFinanceira.nomeArquivo
            ? form.liquidacaoFinanceira.nomeArquivo
            : form.liquidacaoFinanceira.extensao
            ? `LiquidacaoFinanceira.${form.liquidacaoFinanceira.extensao}`
            : ''
        "
        @upload="
          (file, nomeArquivo, extensao) => {
            form.liquidacaoFinanceira.nomeArquivo = nomeArquivo;
            form.liquidacaoFinanceira.base64 = file;
            form.liquidacaoFinanceira.extensao = extensao;
          }
        "
      />

      <template v-if="form.liquidacaoFinanceiraAWS">
        <div>
          Liquidação Financeira
          <div class="lista-arquivos d-flex">
            <b-button
              variant="danger"
              @click="removerArquivo(tipoArquivoCusto.LQ)"
              class="m-2"
              size="sm"
            >
              <b-icon icon="trash" class="mr-2" />
              Remover arquivo
            </b-button>
            <b-button
              variant="info"
              @click="baixarArquivo(form.id, tipoArquivoCusto.LQ)"
              class="m-2"
              size="sm"
            >
              <i class="fas fa-cloud-download"></i>
            </b-button>
            <div
              style="border-left: 1px solid #e5e5e5"
              class="lista-arquivos__left d-flex pl-2 align-items-center"
            >
              {{ form.liquidacaoFinanceiraAWS }}
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import InputText from "@/components/inputs/InputText";
import InputMask from "@/components/inputs/InputMask";
import InputSelect from "@/components/inputs/InputSelect";
import InputTextarea from "@/components/inputs/InputTextarea";
import InputDateTime from "@/components/inputs/InputDateTime";
import InputMoney from "@/components/inputs/InputMoney";
import Upload from "@/components/upload/Upload";
import helpers from "@/common/utils/helpers";
import ProjetoService from "@/common/services/projeto/projeto.service";
import { FormMixin } from "@/common/mixins/FormMixin";
import cloneDeep from "lodash/cloneDeep";
import { START_LOADING, STOP_LOADING } from "@/store/Store";

export default {
  name: "ModalRubricas",
  mixins: [FormMixin],
  components: {
    InputText,
    InputMask,
    InputSelect,
    InputTextarea,
    InputDateTime,
    InputMoney,
    Upload,
  },
  props: {
    projetoId: {
      type: String,
      required: true,
    },
    projetoIdBase: {
      type: String,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    options: {
      empresas: [],
      tipoDocumento: [
        { value: "CPF", text: "CPF" },
        { value: "CNPJ", text: "CNPJ" },
      ],
      tipoDocumentoProjeto: helpers.getTiposDocumentoProjeto(),
      origemDespesa: helpers.getOrigensDepesas(),
      simnao: [
        { value: "S", text: "Sim" },
        { value: "N", text: "Não" },
      ],
    },
    mascara: {
      cpf: "###.###.###-##",
      cnpj: "##.###.###/####-##",
    },
    tipoArquivoCusto: {
      CP: "CP",
      LQ: "LQ",
    },
    dataReady: false,
  }),
  computed: {
    total: function () {
      return helpers.formatarValor(
        this.form.quantidade * helpers.removerValor(this.form.valorIndividual)
      );
    },
    ehProponente: function () {
      return (
        this.$route.name == "projeto-detalhamento" ||
        this.$route.name == "projeto-detalhamento-proponente-cooperada"
      );
    },
    empresasSelect() {
      if (this.ehProponente) {
        return this.options.empresas.filter((el) => {
          return el.value == this.projetoId;
        });
      } else {
        return this.options.empresas;
      }
    },
  },
  methods: {
    buscarEmpresas: function () {
      ProjetoService.listarEmpresasInvestidoras(this.projetoIdBase).then(
        (response) => {
          this.options.empresas = response.data.data.map((el) => {
            return {
              value:
                el.projetoInvestidoraId || el.projetoCooperadaInvestidoraId,
              text: el.razaoSocial,
              el: el,
            };
          });
        }
      );
    },
    baixarArquivo: function (custoId, arquivoTipo) {
      this.$store.dispatch(START_LOADING);

      const endpointOriginal = ProjetoService.getEndpoint();
      ProjetoService.setEndpoint("Projeto");

      ProjetoService.downloadArquivoCustoGenerico(custoId, arquivoTipo)
        .then((response) => {
          helpers.baixarArquivo(response.data, response.headers);
          this.alertaSucesso("Download do Arquivo Concluido!");
        })
        .catch((err) => {
          console.log(err);
          this.alertaErro("Erro ao fazer Download do Arquivo");
        })
        .finally(() => {
          ProjetoService.setEndpoint(endpointOriginal);
          this.$store.dispatch(STOP_LOADING);
        });
    },
    removerArquivo: function (arquivoTipo) {
      this.$store.dispatch(START_LOADING);

      if (arquivoTipo == "CP") this.form.comprovanteAWS = null;
      else this.form.liquidacaoFinanceiraAWS = null;

      this.$store.dispatch(STOP_LOADING);
    },
  },
  async mounted() {
    await this.buscarEmpresas();
    if (this.ehProponente && !this.form.empresa) {
      this.form.empresa = this.projetoId;
    }
  },
  watch: {
    "form.empresa": function (novo) {
      this.form.empresaObj = cloneDeep(
        this.options.empresas.find((el) => el.value == novo).el
      );
      this.dataReady = true;
    },
  },
};
</script>
<style>
.lista-arquivos {
  border: 1px solid #e5e5e5;
  background: #f9f9f9;
}
.lista-arquivos__no_top {
  border-top: none;
}
.lista-arquivos__left {
  border-left: 1px solid #e5e5e5;
}
</style>